import { TypographyCaps } from '../typography'
import clsx from 'clsx'
import { type ReactNode } from 'react'

const Counter = ({
	children,
	size = 'medium',
	...props
}: {
	children: ReactNode
	size?: 'small' | 'medium' | 'large'
}) => {
	return (
		<div
			className={clsx(
				size === 'small' && 'h-[18px] min-w-[30px] p-0.5 pt-1',
				size === 'medium' && 'h-[24px] min-w-[47px] p-1',
				size === 'large' && 'h-[30px] min-w-[62px] p-1.5',
				'flex cursor-pointer items-center justify-center text-ellipsis rounded-full bg-uiPrimaryLight text-textSecondaryLight hover:bg-uiPrimaryDark hover:text-textPrimaryDark dark:bg-uiSecondaryDark dark:text-textSecondaryDark dark:hover:bg-uiSecondaryLight dark:hover:text-textPrimaryLight',
			)}
			{...props}
		>
			<TypographyCaps size={size}>{children || 0}</TypographyCaps>
		</div>
	)
}

export default Counter
